import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { parceiroService } from '@/services/parceiro.service'
import type { Parceiro, UUID } from '@/types/database'

export function useParceiros(filters?: { search?: string }) {
    return useQuery({
        queryKey: ['parceiros', filters],
        queryFn: () => parceiroService.list(filters),
    })
}

export function useAllParceiros() {
    return useQuery({
        queryKey: ['parceiros', 'all'],
        queryFn: parceiroService.getAll,
    })
}

export function useCreateParceiro() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: parceiroService.create,
        onSuccess: () => qc.invalidateQueries({ queryKey: ['parceiros'] }),
    })
}

export function useUpdateParceiro() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({ id, ...data }: Partial<Parceiro> & { id: UUID }) => parceiroService.update(id, data),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['parceiros'] }),
    })
}

export function useDeleteParceiro() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: parceiroService.remove,
        onSuccess: () => qc.invalidateQueries({ queryKey: ['parceiros'] }),
    })
}

export function useRegenerateApiKey() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: parceiroService.regenerateApiKey,
        onSuccess: () => qc.invalidateQueries({ queryKey: ['parceiros'] }),
    })
}
